import FormFieldFromProps from '@App/kit/fields/v2/FormFieldFromProps'
import React from 'react'
import { FormFieldType } from '@App/forms/v2/common/form-field'
import { InternationalPhoneNumberType } from '@Entities/schemas/common/international-phone-number-schema'

interface ContactInfoSectionProps {
    email: FormFieldType<string>
    fullPhoneNumber: FormFieldType<InternationalPhoneNumberType>
    disableEmail?: boolean
}

const ContactInfoInterPhoneSection = ({ email, disableEmail, fullPhoneNumber }: ContactInfoSectionProps) => (
    <section className="contact-info-section">
        <h5>Contact Information</h5>
        <div className="fields-row-container">
            <FormFieldFromProps field={fullPhoneNumber} />
            <FormFieldFromProps field={email} isDisabled={disableEmail} />
        </div>
    </section>
)
export default ContactInfoInterPhoneSection
